





































































































































































































































































































































































































































































































































































































import moment from 'moment'
import settings from '@/settings.coffee'
import queries from "@/gql/queries.coffee"
import tools from "@/tools.coffee"
import EstablishmentLogo from '@/components/EstablishmentLogo'
import EstablignmentGatheringLine from '@/components/EstablignmentGatheringLine'
import Reports from '@/components/Reports'
import Footer from '@/components/Footer'
import VotreConsultant from '@/components/VotreConsultant'
import GatheringStats from '@/components/GatheringStats'
import GatheringReviewDetail from '@/components/GatheringReviewDetail'

export default {
    "name": 'GatheringHome'
    "components": {
        EstablishmentLogo,
        EstablignmentGatheringLine,
        Reports,
        Footer,
        VotreConsultant,
        GatheringStats,
        GatheringReviewDetail}
    "data": ()->
        return {
            "loading": true,
            "navStyle":"display:none !important;"    
            "date_filter": "one_week"
            "sortOrder": ["establishment", "name"]
            "sortDirection": "ASC"
            "filter": 'todo'
            "gathering": null
            "can_export_reviews": false
            "iframeHeight": 500
            "winHeight": 500    
            "export_start": null
            "export_end": null
            "establishments": []
            "otherLinks": []
            "helpLink": {label:null, href:null}
            "statsLink": {label:null, href:null}
            "staff": null
            "current_review": null
            "reviews": []
            "reports": []
            "reviews_count": 0
            "current_establishment": ""
            "showing": null
            "reports_access": null
            "validation_roles": null
            "review_download": settings.backendUrl+"/admin/review/export/"
            "logo_hotel":""
            "all":{
                    nb_infoneeded:0
                    nb_answerwriting:0
                    nb_signaling:0
            }
            "activeHelpLink": null
        }
    "computed": {
        to_be_done: ()->
            ret = 0
            for r in this.reviews
                if not @is_done(r)
                    ret += 1
            return ret
        done: ()->
            ret = 0
            for r in this.reviews
                if @is_done(r)
                    if r.current_state.class_name != "Classified"
                        ret += 1                        
                    else if this.date_filter == "one_week"
                        if moment(r.scraped_on).isAfter(moment().subtract(7,'days'))
                            ret += 1
                    else if this.date_filter == "one_month"
                        if moment(r.scraped_on).isAfter(moment().subtract(1,'months'))
                            ret += 1
                    else if this.date_filter == "last_month"
                        ret += 1
            return ret
        settings: ()->
            return settings
        filteredReviews: ()->
            self = this
            ret = []
            for r in this.reviews
                if this.filter == "done"
                    if @is_done(r)
                        ret.push(r)
                else if this.filter == "todo"
                    if not @is_done(r)
                        ret.push(r)
                else
                    ret.push(r)
            ret2 = []
            for r in ret
                if r.current_state.class_name != "Classified"
                    ret2.push(r)                        
                else if this.date_filter == "one_week"
                    if moment(r.scraped_on).isAfter(moment().subtract(7,'days'))
                        ret2.push(r)
                else if this.date_filter == "one_month"
                    if moment(r.scraped_on).isAfter(moment().subtract(1,'months'))
                        ret2.push(r)                        
                else if this.date_filter == "last_month"
                    #if moment(r.scraped_on).isAfter(moment().startOf('month').subtract(1,'months'))
                    ret2.push(r)

            @sortOrder
            ret2.sort((a, b)->
                #if a.current_state.class_name != "Classified" and b.current_state.class_name != "Classified"
                    # nothing
                #else if a.current_state.class_name != "Classified"
                #    return -1
                #else if b.current_state.class_name != "Classified"
                #    return 1
                va = a
                vb = b
                for col in self.sortOrder
                    va = va[col]
                    vb = vb[col]

                if self.sortDirection == "ASC"
                    if va.localeCompare?
                        return va.localeCompare(vb)
                    else
                        if va > vb
                            return 1
                        else if va == vb
                            return 0
                        else
                            return -1
                else
                    if va.localeCompare?
                        return  vb.localeCompare(va)
                    else
                        if vb > va
                            return 1
                        else if vb == va
                            return 0
                        else
                            return -1
            )
            return ret2
        
    },
    "methods":
        "is_done": (review)->
            return not (
                review.current_state.class_name=='AnswerTextValidation' or
                review.current_state.class_name=='WaitingForInformation' or 
                review.current_state.class_name=='SignalingWriting' or
                review.current_state.class_name=='SignalingSent'
            )
        "hasAccessToHistory": ()->

            if @current_establishment == 'all'
                ret = false
                for key of @$store.state.profile.data.can_view_history
                    if @$store.state.profile.data.can_view_history[key] != 'no_access'
                        ret = true
            else
                ret = @$store.state.profile.data.can_view_history[@current_establishment.uid]? &&
                @$store.state.profile.data.can_view_history[@current_establishment.uid] != "no_access"
                
            return ret
        "hasAccessToFilter": (filter_name)->
            ret = false
            for key of @$store.state.profile.data.can_view_history
                if @$store.state.profile.data.can_view_history[key] == filter_name
                    ret = true
            return ret
        "orderBy": (cols)->
            if @sortOrder.toString() == cols.toString()
                @sortDirection = if @sortDirection == "ASC" then "DESC" else "ASC"

            @sortOrder = cols
        "exportReviews": ()->
            @$http.post(
                @review_download,
                {
                    start:@$refs.export_start.value,
                    end: @$refs.export_end.value
                },
                {responseType:'blob'}
            ).then (response)->
                fileURL = window.URL.createObjectURL(new Blob([response.body]));
                fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'export.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
            
        "openModelSelectEstablishment": ()->
            @$refs.selectHotelModel.classList.add('is-active')
            return
        "closeModelSelectEstablishment": ()->
            if @$refs.selectHotelModel
                @$refs.selectHotelModel.classList.remove('is-active')
            return
        "show_reports": ()->
            vm = this
            vm.showing = 'reports'
        "logout": ()->
            this.$http.get(settings.authApiUrlLogout)
            .then ()->
                location.reload()        
        "selectReview": (evnt, arg)->
            vm = this
            vm.showing = 'review_detail'
            vm.current_review = evnt.detail
            for e in vm.establishments
                if e.uid == evnt.detail.establishment.uid
                    vm.current_establishment = e
            vm.$router.push('/g/' + vm.current_establishment.uid + '/' + evnt.detail.uid)
            
        "get_class": (state_name)->
            return ['state-'+state_name.toLowerCase()]
        "selectEstablishment": (establishment, review_uid)->
            self = @
            self.loading = true
            #if establishment.uid == self.current_establishment.uid
            #    return
            self.closeModelSelectEstablishment()
            self.showing = 'review_list'
            if establishment == 'all'
                self.current_establishment = "all"
                self.$router.push('/g/all')
                r_done = await queries.run("get_review_done_set")
                # -- LOT3 - new state direct to establihsment:
                #    AnswerTextValidation, WaitingForInformation
                r2 = await queries.run("get_reviews_to_process")
                if r2.ok
                    self.reviews = r2.body.data.reviews_to_process

                    for r in r_done.body.data.review_done_set
                        self.reviews.push(r)

                    self.all.nb_infoneeded = 0
                    self.all.nb_answerwriting = 0
                    self.all.nb_signaling = 0
                    for r in self.reviews
                        if (
                            r.current_state.class_name == "InformationNeeded" or
                            r.current_state.class_name == "WaitingForInformation"
                        )
                            self.all.nb_infoneeded += 1
                        if r.current_state.class_name == "AnswerTextValidation"
                            self.all.nb_answerwriting += 1
                        if (
                            r.current_state.class_name == "SignalingWriting" or
                            r.current_state.class_name == "SignalingSent"
                        )
                            self.all.nb_signaling += 1
            else
                self.current_establishment = establishment
                r = await queries.run("get_staff_establishments",
                                      [@$store.state.profile.data.uid])
                if r.ok
                    @establishments = r.body.data.get_staff_establishments            
                    for e in @establishments
                        if e.uid == establishment.uid
                            self.current_establishment = e

                r = await queries.run("get_staff_statslink", [
                        @$store.state.profile.data.uid,
                        self.current_establishment.uid])
                if r.ok

                    @statsLink =  {href: r.body.data.staff_statslink}

                r_done = await queries.run("get_review_done_set", [establishment.uid])

                # -- LOT3 - new state direct to establihsment:
                #    AnswerTextValidation, WaitingForInformation
                r2 = await queries.run("get_reviews_to_process", [establishment.uid])
                if r2.ok
                    self.reviews = r2.body.data.reviews_to_process

                    for r in r_done.body.data.review_done_set
                        self.reviews.push(r)
                        
                    if review_uid
                         for r in self.reviews
                             if r.uid == review_uid
                                 self.selectReview({detail:r})
                                 self.$router.push('/g/'+establishment.uid+'/'+review_uid)

                    else
                        self.$router.push('/g/'+establishment.uid)
            self.loading = false
        "resetActiveLinks": ()->
            for link in @otherLinks
                document.getElementById('link_' + link.uid)?.classList.remove('active')

            document.getElementById('click_gathering_stats')?.classList.remove('active')
            document.getElementById('click_gathering_review_list')?.classList.remove('active')
            document.getElementById('click_gathering_show_report')?.classList.remove('active')
            return
        "handleHelpLinkClick": (link)->
            self = @
            self.resetActiveLinks()
            for l in @otherLinks
                if link.uid == l.uid 
                  document.getElementById('link_'+link.uid)?.classList.add('active') # add active on a dynamic link

            @activeHelpLink = link
            @helpLink = link
            @showing = 'help'
            return
        "initializeCustomEvents": ->
            self = @     
            @otherLinks.forEach (link) ->
              window.addEventListener "click_help_#{link.uid}", -> 
                self.handleHelpLinkClick(link)
        "fetch_data": ()->
            self = @
            r = await queries.run("get_links")
            if r.ok
              @otherLinks = r.body.data.link_set
              #@.$nextTick ->
              #  console.log "DOM mis à jour !"
                  
            r = await queries.run("get_staff_roles",
                                  [@$store.state.profile.data.uid])
            if r.ok
                @reports_access = {}
                @validation_roles = {}
                for role in r.body.data.get_staff_roles
                    @reports_access[role.establishment.uid] = role.report_access
                    @validation_roles[role.establishment.uid] = role.text_role
            r = await queries.run("get_gathering_from_staff",
                                  [@$store.state.profile.data.uid])
            if r.ok
                @gathering = r.body.data.get_gathering_form_staff

            
            r = await queries.run("get_staff_establishments",
                                  [@$store.state.profile.data.uid])
            if r.ok
                self.establishments = r.body.data.get_staff_establishments
                if self.$route.params.establishment_uid
                    selected = false
                    if self.$route.params.establishment_uid == 'all'
                        self.selectEstablishment('all')
                    else
                        for e in @establishments
                            if e.uid == @$route.params.establishment_uid
                                self.selectEstablishment(e, self.$route.params.review_uid+"")
                                selected = true
                        if not selected
                            self.selectEstablishment(self.establishments[0])
                else
                    if self.establishments.length > 1
                        self.selectEstablishment('all')
                    else
                        self.selectEstablishment(self.establishments[0])
            @$refs.menu.removeAttribute("style");

                 
    "created": ()->
        self = @
        self.$djangows['onmodelsignals'] {"modelName": "email", "appLabel": "core"}, (event)->
            #console.log("email", event)
    watch:{
        $route: (to, from)->
            regex = /^\/g\/((?:\w|-)+)$/g
            m = regex.exec(to.path);
            if m
                if m[1] == "all" and m[1] != @current_establishment.uid
                  @selectEstablishment('all')
                else
                  for e in @establishments
                    if e.uid == m[1] #and m[1] != @current_establishment.uid
                      @selectEstablishment(e)
            return
        
        otherLinks:
              handler: (newVal, oldVal) ->
              deep: true
        
    } 
    "mounted": ()->
        vm = @
        # temporary remove the 'menu' id before fetching to stop javascript loading in order to manage bug when we retrieve dynamically links
        originalMenu = document.getElementById('menu')
        if originalMenu
          originalMenu.id = 'menu_temp'
        await vm.fetch_data()
        setTimeout(=>
          tempMenu = document.getElementById('menu_temp')
          if tempMenu
            tempMenu.id = 'menu'
            @initializeCustomEvents()
        , 200)
        # end
        window.addEventListener('resize', ()->
                vm.iframeHeight = $(document).height()-40;
                vm.winHeight = $(document).height()-120;
                return
            );
        setTimeout(()->
          vm.navStyle=""
          return
        , 500)
        vm.iframeHeight = $(document).height()-40;
        vm.winHeight = $(document).height()-120;
        setTimeout(()->
            new AcornIcons().replace()
            # -- defined in /public/js/scripts
            scripts = new Scripts();
            setTimeout(()->
                $('.datepicker').datepicker({
                        autoclose:true,
                        format:"dd/mm/yyyy",
                        weekStart: 1,
                        language: 'fr'});
                return
            ,2000)
            return
        ,100)
        
        window.addEventListener(
            'click_gathering_show_report',
            ()->
                vm.show_reports()
                vm.resetActiveLinks() # reset
                document.getElementById('click_gathering_show_report').classList.add('active')
                window.gatheringNav._hideMobileMenu()                
                return
            ,
            false);
        window.addEventListener(
            'click_gathering_review_list',
            (e)->
                vm.resetActiveLinks() # reset
                document.getElementById('click_gathering_review_list').classList.add('active')
                etab = vm.establishments[0]
                if vm.current_establishment
                    etab = vm.current_establishment

                vm.selectEstablishment(etab)
                window.gatheringNav._hideMobileMenu()
                return
            ,
            false);
        window.addEventListener(
            'click_gathering_logout',
            ()->
                vm.logout()
                return
            ,
            false);
        window.addEventListener(
            'click_gathering_review_detail',
            (arg)->
                vm.selectReview(arg)
                return
            ,
            false);
        window.addEventListener(
            'click_gathering_stats',
            (arg)->
                vm.resetActiveLinks() # reset
                document.getElementById('click_gathering_stats').classList.add('active')
                vm.showing = "stats"
                window.gatheringNav._hideMobileMenu()                
                return
            ,
            false);
        
        
}
